export default __webpack_public_path__ + "static/bg_ebook-e97c67787a74ed1c561b2b797a94ee27.jpg";